import React, { useEffect, useState } from 'react'
import { useMediaQuery, Box, styled } from '@mui/material'
import { Typography, Button, IconButton } from '@evocolabs/orkaui'
import theme from '@evocolabs/orkaui/lib/theme.cjs'
import ArrowLeft24 from '@evocolabs/icons/lib/ArrowLeft24'
import Calendar120 from '@evocolabs/icons/lib/Calendar120'
import AccountPaper from '@/components/Account/AccountPaper'
import ScheduleRoot from '@/components/Schedule/ScheduleRoot'
import { useBackend } from '@/src/providers/BackendProvider'
import {
  CalendarProvider,
  floorToHour
} from '@/components/Schedule/Calendar/CalendarProvider'

const Label = styled(Box)`
  border-radius: 8px;
  padding: 8px;
  background-color: ${(props) =>
    props.status === 'scheduled'
      ? theme.palette.primary[500]
      : theme.palette.grey[500]};
  width: fit-content;
  min-width: 100px;
  height: fit-content;
  margin-right: 16px;
  ${(props) => props.theme.breakpoints.down('md')} {
    margin-bottom: 12px;
  }
`

const ContactAudiologist = () => {
  const { appointment } = useBackend()
  const [view, setView] = useState('schedule')
  const [params, setParams] = useState({
    ...appointment.filter(
      (e) =>
        e.status === 'scheduled' &&
        new Date(e.start_time).getTime() > Date.now()
    )[0],
    id: appointment.some(
      (e) =>
        e.status === 'scheduled' &&
        new Date(e.start_time).getTime() > Date.now()
    )
      ? appointment.filter(
          (e) =>
            e.status === 'scheduled' &&
            new Date(e.start_time).getTime() > Date.now()
        )[0].id
      : null
  })
  const usePC = !useMediaQuery(theme.breakpoints.down('md'))
  if (!usePC) {
    if (view === 'records') {
      const _tempNode = document.querySelector('header')
      _tempNode.style.cssText += 'visibility:hidden'
    } else {
      const _tempNode = document.querySelector('header')
      _tempNode.style.cssText += 'visibility:unset'
    }
  }

  useEffect(() => {
    if (
      appointment.some(
        (e) =>
          e.status === 'scheduled' &&
          new Date(e.start_time).getTime() > Date.now()
      )
    ) {
      const activeAppointment = appointment.filter(
        (e) =>
          e.status === 'scheduled' &&
          new Date(e.start_time).getTime() > Date.now()
      )[0]
      setParams({
        ...activeAppointment,
        id: activeAppointment.id
      })
    } else {
      setParams({
        id: null
      })
    }
  }, [appointment])

  return (
    <div style={{ width: '100%', textAlign: 'center' }}>
      {view === 'schedule' && (
        <>
          {usePC && (
            <AccountPaper style={{ backgroundColor: 'unset' }}>
              <div
                style={{
                  marginBottom: '16px',
                  backgroundColor: '#ffffff',
                  borderRadius: '12px',
                  padding: '16px 40px',
                  display: 'flex',
                  justifyContent: 'space-between'
                }}
              >
                <Typography variant="h3">Contact Audiologist</Typography>
                <Button
                  variant="textprimary"
                  handleClick={() => setView('records')}
                >
                  My Consultations
                </Button>
              </div>
            </AccountPaper>
          )}
          <CalendarProvider>
            <ScheduleRoot params={params} />
          </CalendarProvider>
          {!usePC && (
            <Button
              variant="textprimary"
              handleClick={() => setView('records')}
              style={{ margin: '-54px auto auto' }}
            >
              My Consultations
            </Button>
          )}
        </>
      )}
      {view === 'records' && (
        <>
          {usePC ? (
            <AccountPaper style={{ backgroundColor: 'unset' }}>
              <div
                style={{
                  marginBottom: '16px',
                  backgroundColor: '#ffffff',
                  borderRadius: '12px',
                  padding: '16px 40px',
                  display: 'flex',
                  alignItems: 'center'
                }}
              >
                <IconButton
                  onClick={() => {
                    setView('schedule')
                  }}
                >
                  <ArrowLeft24 />
                </IconButton>
                <Typography variant="h3" sx={{ ml: '10px' }}>
                  My Consultations
                </Typography>
              </div>
            </AccountPaper>
          ) : (
            <Box
              sx={{
                bgcolor: '#ffffff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                position: 'absolute',
                left: 0,
                top: 0,
                width: '100%',
                height: '48px',
                boxShadow: '10px 5px 50px 10px rgba(242, 242, 242, 0.5)'
              }}
            >
              <Box sx={{ position: 'absolute', left: 16 }}>
                <IconButton onClick={() => setView('schedule')}>
                  <ArrowLeft24 />
                </IconButton>
              </Box>
              <Typography variant="subh1">My Consultations</Typography>
            </Box>
          )}
          {appointment.length !== 0 ? (
            <AccountPaper
              style={{ padding: usePC ? '32px 40px' : '32px 16px' }}
            >
              <Box
                sx={{
                  borderRadius: '8px',
                  bgcolor: theme.palette.grey[100],
                  p: usePC ? '24px' : '24px 16px'
                }}
              >
                {appointment
                  .sort(function (a, b) {
                    return a.id < b.id
                  })
                  .map((item, idx) => (
                    <>
                      {idx !== 0 && (
                        <Box
                          sx={{
                            m: '16px 0',
                            bgcolor: theme.palette.grey[400],
                            height: '1px'
                          }}
                        />
                      )}
                      <Box
                        sx={{
                          display: usePC ? 'flex' : 'unset',
                          alignItems: 'center'
                        }}
                      >
                        <Label status={item.status}>
                          <Typography
                            variant="subh2"
                            sx={{
                              color: theme.palette.white.main,
                              textTransform: 'capitalize',
                              textAlign: 'center'
                            }}
                          >
                            {item.status}
                          </Typography>
                        </Label>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            flexGrow: 1
                          }}
                        >
                          <Box>
                            <Typography
                              variant="subh2"
                              sx={{
                                color: theme.palette.grey[600],
                                lineHeight: 'inherit'
                              }}
                            >
                              Name
                            </Typography>
                            <Typography
                              variant="h4"
                              sx={{ color: theme.palette.grey[700] }}
                            >
                              {item.user_name}
                            </Typography>
                          </Box>
                          <Box>
                            <Typography
                              variant="subh1"
                              sx={{ color: theme.palette.grey[700] }}
                            >
                              {new Date(item.start_time).toDateString()}
                            </Typography>
                            <Typography
                              variant="subh1"
                              sx={{ color: theme.palette.grey[700] }}
                            >
                              {new Date(item.start_time)
                                .toTimeString()
                                .substring(0, 5)}{' '}
                              -{' '}
                              {new Date(item.end_time)
                                .toTimeString()
                                .substring(0, 5)}
                            </Typography>
                          </Box>
                        </Box>
                      </Box>
                    </>
                  ))}
              </Box>
            </AccountPaper>
          ) : (
            <AccountPaper
              style={{ padding: usePC ? '32px 40px' : '32px 16px' }}
            >
              <Calendar120 />
              <Typography variant="subh1" sx={{ textAlign: 'center' }}>
                You have not booked any consultations yet.
              </Typography>
            </AccountPaper>
          )}
        </>
      )}
    </div>
  )
}

export default ContactAudiologist
